import React, { useContext } from 'react';
import { Controller } from 'react-hook-form';
import 'moment/locale/en-au';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { SearchBarContext } from '../../../../components/SearchBar';
import SearchBarRow from '../../../../components/SearchBar/SearchBarRow';
import DatePicker, { registerLocale } from 'react-datepicker';
import de from 'date-fns/locale/de';
registerLocale('de', de);
import es from 'date-fns/locale/es';
registerLocale('es', es);
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr);

const PrimarySearchItems = () => {
  const intl = useIntl();
  const { register, control } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group" style={{ flex: 1 }}>
        <label>{intl.formatMessage({ id: 'users.search.email-field' })}</label>
        <input className="form-control" {...register('email')}></input>
      </div>

      <div className="form-group" style={{ flex: 1 }}>
        <label>{intl.formatMessage({ id: 'users.search.first-name-field' })}</label>
        <input className="form-control" {...register('firstName')}></input>
      </div>

      <div className="form-group" style={{ flex: 1 }}>
        <label>{intl.formatMessage({ id: 'users.search.last-name-field' })}</label>
        <input className="form-control" {...register('lastName')}></input>
      </div>

      <div className="form-group" style={{ flex: 1 }}>
        <label>{intl.formatMessage({ id: 'users.search.last-login-field' })}</label>
        <div className="date-range">
          <Controller
            control={control}
            name="lastLoginStart"
            render={({ field }) => (
              <DatePicker
                name="lastLoginStart"
                className="form-control"
                placeholderText={intl.formatMessage({ id: 'shared.forms.start_date' })}
                selected={field.value ? moment(field.value).toDate() : undefined}
                onChange={(date) => field.onChange(date)}
                dateFormat={window._FLAIM_DATE_FORMAT}
                locale={window._FLAIM_LOCALE}
              />
            )}
          />

          <Controller
            control={control}
            name="lastLoginEnd"
            render={({ field }) => (
              <DatePicker
                name="lastLoginEnd"
                className="form-control"
                placeholderText={intl.formatMessage({ id: 'shared.forms.end_date' })}
                selected={field.value ? moment(field.value).toDate() : undefined}
                onChange={(date) => field.onChange(date)}
                dateFormat={window._FLAIM_DATE_FORMAT}
              />
            )}
          />
        </div>
      </div>
    </SearchBarRow>
  );
};

export { PrimarySearchItems };
